import { Text } from "@design-system/Text/Text";

type Props = {
  /** MSP home lists problem tenants; tenant home shows that tenant's coverage. */
  variant: "msp" | "tenant";
};

/**
 * Holds the coverage slot until AF-555 ships healthy / in-scope.
 * Do not substitute extension adoption rate here.
 */
export const CoveragePlaceholderCard = ({ variant }: Props) => {
  const emptyMessage =
    variant === "msp"
      ? "Tenants with low or dropping coverage are not available yet."
      : "Coverage for this tenant is not available yet.";

  return (
    <Text size={12} color="textSecondary">
      {emptyMessage}
    </Text>
  );
};
